import { render } from "./CoBrandOverlap.vue?vue&type=template&id=30c0964f&scoped=true"
import script from "./CoBrandOverlap.vue?vue&type=script&lang=js"
export * from "./CoBrandOverlap.vue?vue&type=script&lang=js"

import "./CoBrandOverlap.vue?vue&type=style&index=0&id=30c0964f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c0964f"]])

export default __exports__